import React, { useEffect, useState } from 'react';
import { books_category } from '../ProData';
import Carousel from 'react-bootstrap/Carousel';

export default function BookCategoryCaroselHome() {
  const [booksCategory, setBooksCategory] = useState([]);

  useEffect(() => {
    const tempBooks = books_category.filter((item) => item.categoryDisplay === 'Yes');
    setBooksCategory(tempBooks);
  }, []);

  // Split categories into chunks for carousel slides (3 per slide)
  const chunkSize = 3;
  const categoryChunks = [];
  for (let i = 0; i < booksCategory.length; i += chunkSize) {
    categoryChunks.push(booksCategory.slice(i, i + chunkSize));
  }

  return (
    <div style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%)', minHeight: '100vh', fontFamily: 'Inter, Segoe UI, Arial, sans-serif' }}>
      <style>{`
        .bookcat-carousel-section {
          padding: 48px 0 32px 0;
        }
        .bookcat-carousel-title {
          font-size: 2.2rem;
          font-weight: 700;
          color: #2a3659;
          margin-bottom: 0.5rem;
        }
        .bookcat-carousel-desc {
          color: #5a6a85;
          font-size: 1.1rem;
          margin-bottom: 2.5rem;
        }
        .bookcat-carousel {
          max-width: 900px;
          margin: 0 auto;
        }
        .bookcat-card-row {
          display: flex;
          gap: 2rem;
          justify-content: center;
          align-items: stretch;
          margin-bottom: 1.5rem;
        }
        .bookcat-card {
          background: linear-gradient(135deg, #e3eafc 0%, #f6f8fc 100%);
          border-radius: 18px;
          box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.08);
          padding: 1.5rem 1.2rem 1.2rem 1.2rem;
          flex: 1 1 0;
          min-width: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: box-shadow 0.2s, transform 0.2s;
          height: 400px;
          min-height: 400px;
          max-height: 440px;
        }
        .bookcat-card-img {
          width: 80px;
          height: 80px;
          object-fit: contain;
          margin-bottom: 1rem;
          border-radius: 12px;
          background: #fff;
          box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.07);
        }
        .bookcat-card-title {
          font-size: 1.15rem;
          font-weight: 600;
          color: #2a3659;
          margin-bottom: 0.5rem;
          text-align: center;
        }
        .bookcat-card-desc {
          color: #5a6a85;
          font-size: 0.98rem;
          text-align: center;
          flex: 1 1 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          word-break: break-word;
          padding: 0 2px;
          overflow: visible;
          max-height: none;
        }
        .bookcat-card {
          /* ...existing styles... */
          overflow: hidden;
        }
        .bookcat-card:hover {
          box-shadow: 0 8px 32px 0 rgba(44, 62, 80, 0.16);
          transform: translateY(-4px) scale(1.03);
        }
        .bookcat-card-img {
          width: 80px;
          height: 80px;
          object-fit: contain;
          margin-bottom: 1rem;
          border-radius: 12px;
          background: #fff;
          box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.07);
        }
        .bookcat-card-title {
          font-size: 1.15rem;
          font-weight: 600;
          color: #2a3659;
          margin-bottom: 0.5rem;
          text-align: center;
        }
        .bookcat-card-desc {
          color: #5a6a85;
          font-size: 0.98rem;
          text-align: center;
        }
        @media (max-width: 900px) {
          .bookcat-card-row {
            gap: 1rem;
          }
        }
        @media (max-width: 700px) {
          .bookcat-card-row {
            flex-direction: column;
            gap: 1.5rem;
          }
        }
      `}</style>
      <section className="bookcat-carousel-section">
        <div className="container bookcat-carousel">
          <div className="heading_container heading_center">
            <h2 className="bookcat-carousel-title">Books Categories</h2>
            <p className="bookcat-carousel-desc">
              Our library provides a wide range of reading materials, with 65 distinct book categories and over 2,000 specific classifications.
            </p>
          </div>
          <Carousel interval={5000} pause={false} indicators={categoryChunks.length > 1}>
            {categoryChunks.map((chunk, idx) => (
              <Carousel.Item key={idx}>
                <div className="bookcat-card-row">
                  {chunk.map((item, i) => (
                    <div className="bookcat-card" key={item.name + i}>
                      <img className="bookcat-card-img" src={item.categoryImage} alt={item.name} />
                      <div className="bookcat-card-title">{item.name}</div>
                      <div className="bookcat-card-desc">{item.categoryDesc}</div>
                    </div>
                  ))}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </section>
    </div>
  );
}
